import lazyLoading from './lazyLoading'

export default {
  name: 'ChangePassword',
  path: '/change_password',
  hidden: true,
  meta: {
    auth: true,
    link: 'article_writer/',
    label: 'Change Password'
  },
  component: lazyLoading('changePassword', true)
}
